import type { Directive } from 'vue';

const VISIBLE_CLASS = 'below-fold-render-section--visible';
const RENDER_ROOT_MARGIN = '800px 0px';

let observer: IntersectionObserver | null = null;

const observedElements = new Set<Element>();

/**
 * Раскрывает секцию один раз и исключает ее из дальнейшего наблюдения.
 */
const showElement = (element: Element) => {
  element.classList.add(VISIBLE_CLASS);
  observer?.unobserve(element);
  observedElements.delete(element);
};

/**
 * Возвращает общий IntersectionObserver для всех нижних секций листинга.
 */
const getObserver = () => {
  if (observer) {
    return observer;
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          showElement(entry.target);
        }
      });
    },
    {
      rootMargin: RENDER_ROOT_MARGIN,
      threshold: 0,
    },
  );

  return observer;
};

/**
 * Освобождает observer, когда на странице не осталось отслеживаемых секций.
 */
const disconnectObserverIfEmpty = () => {
  if (observedElements.size > 0) {
    return;
  }

  observer?.disconnect();
  observer = null;
};

export const vBelowFoldRender: Directive<HTMLElement> = {
  mounted(element) {
    if (typeof IntersectionObserver === 'undefined') {
      showElement(element);

      return;
    }

    observedElements.add(element);

    getObserver().observe(element);
  },

  unmounted(element) {
    observer?.unobserve(element);
    observedElements.delete(element);
    disconnectObserverIfEmpty();
  },
};
